import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import './App.css';
import AppRouter from './routes/AppRouter';
import configureStore from './redux';
// import PWAInstallPrompt from './components/PWAInstallPrompt';
import MobileInstallTopBar from './components/MobileInstallTopBar';
import OfflineIndicator from './components/OfflineIndicator';
import './i18n'; // Initialize i18n

const { store, persistor } = configureStore();

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <PersistGate loading={null} persistor={persistor}>
          <div className="App">
            <OfflineIndicator />
            <AppRouter />
            {/* <PWAInstallPrompt /> */}
            <MobileInstallTopBar />
          </div>
        </PersistGate>
      </BrowserRouter>
    </Provider>
  );
}
export default App;
